$(function () {
  $(".mini_slider_wraper").slick({
    arrows: false,
    autoplay: true,
    adaptiveHeight: true,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0559/1328/3607/files/prev.png?v=1682634912" class="slide-arrow prev-arrow">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0559/1328/3607/files/next.png?v=1682634912" class="slide-arrow next-arrow">',
    dots: true,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 600, // 399px以下のサイズに適用
        settings: {
          slidesToShow: 1,
          variableWidth: true,
        },
      },
    ],
  });

  $(".mini_slider_wraper_g").slick({
    variableWidth: true,
    centerMode: true,
    arrows: false,
    autoplay: true,
    adaptiveHeight: true,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0559/1328/3607/files/prev.png?v=1682634912" class="slide-arrow prev-arrow">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0559/1328/3607/files/next.png?v=1682634912" class="slide-arrow next-arrow">',
    dots: true,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 400, // 399px以下のサイズに適用
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".blog-slider-wraper").slick({
    arrows: false,
    autoplay: true,
    adaptiveHeight: true,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0559/1328/3607/files/prev.png?v=1682634912" class="slide-arrow prev-arrow">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0559/1328/3607/files/next.png?v=1682634912" class="slide-arrow next-arrow">',
    dots: true,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 600, // 399px以下のサイズに適用
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

$(".top-product-slider").slick({
  autoplay: false,
  arrows: false,
  fade: true,
  asNavFor: ".top-product-slider-thumbnail",
});
$(".top-product-slider-thumbnail").slick({
  slidesToShow: 5,
  asNavFor: ".top-product-slider",
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
});

/*
$(".mini_slider_wraper").slick({
  autoplay: true,
  autoplaySpeed: 5000,
  dots: true,
  arrows: true,
  responsive: [
    {
      breakpoint: 1024, // 768〜1023px以下のサイズに適用
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768, // 480〜767px以下のサイズに適用
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480, // 〜479px以下のサイズに適用
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});
*/
